import Pqp from "../3x1010/Pqp.js";
import ServiceManager from "../3x1010/services/ServiceManager.js";
import ServiceManagerUrls from "../3x1010/services/ServiceManagerRoutes.js";
import Globals from "../Globals.js";
import PageCommon from "./PageCommon.js";

export default class PageDrycuracaoIndex2024 extends PageCommon {
    constructor() {
        super();
    }

    init(UidConcorso) {
        super.init();

        // UID da cambiare per l'anno 2024
        this.UidConcorso = UidConcorso;

        this.ageCheck();
        this.initNav();
        this.initForm();

        this.initUploadAll();

        const hidePreloader = setTimeout(() => {
            this.showPreloader(false);
        }, 1000);

        let form = $('.js-form-dry-2024');
        let submitBtn = $('.js-btn-submit', form);
        submitBtn.on('click', (event) => {
            event.preventDefault();
            this.submitFormDryCuracao(form);
        })
    }

    submitFormDryCuracao(form) {
        let data = this.getFormDryCuracaoData(form);

        const rq = new Object({
            partecipante_drycuracao2024ToInsert: data
        });
        this.showPreloader(true);

        if (!this.CheckFormDrycuracaoData(data)) {
            $(".js-form-fields-error", ".library").clone().appendTo(".land").show();

            //Gestione modale in base agli errori
            $(".js-reload", ".land").on("click", (e) => { $(".form-dialog", ".land").remove() });
            $(".js-dialog-close", ".land").on("click", (e) => { $(".form-dialog", ".land").remove() });
            this.showPreloader(false);
            return;
        }

        thatServiceManeger.standardCall("/api/drycuracao2024/doInsConcorso", rq, (rs) => {
            this.ManageFormDryCuracaoResponse(rs);
        });
    }

    //===========================
    // Prende i dati dal form
    //===========================
    getFormDryCuracaoData(form) {
        let data = {
            Nome: $('#user-name', form).val(),
            Cognome: $('#user-surname', form).val(),
            RuoloProfessionale: $('#professional-role', form).val(),
            NomeLocale: $('#store-name', form).val(),
            Telefono: $('#user-phone', form).val(),
            Indirizzo: $('#store-address', form).val(),
            Email: $('#user-email', form).val(),
            UrlInstagramBartender: $('#insta-link-user', form).val(),
            UrlInstagramLocale: $('#insta-link-store', form).val(),
            UrlImmagineBartender: $('.js-img-upload', form).val(),
            UrlVideo: $('.js-video-upload', form).val(),
            NomeCocktail: $('#nome-cocktail', form).val(),
            Ricetta: $('#ricetta', form).val(),
            //MetodoPreparazione: $('#metodo-preparazione', form).val(),
            //Bicchiere: $('#bicchiere', form).val(),
            //Guarnizione: $('#guarnizione', form).val(),
            FLAGPrivacy: $('#privacy-policy', form).prop('checked') ? 1 : 0,
            FLAGPrivacyNewsletter: $('#newsletter', form).prop('checked') ? 1 : 0,
            FLAGPubblicazioneOnline: $('#publish-online', form).prop('checked') ? 1 : 0,
            UidConcorso: "Drycuracao2024"
        }

        return data;
    }

    //======================================================================
    //  Controlla se ci sono errori,
    //  restituisce true se non ce ne sono, altrimenti restituisce false
    //======================================================================
    CheckFormDrycuracaoData(data) {

        //prendo tutti i single-input con un errore
        let fieldsWithErrors = $('.has-error');
        if (fieldsWithErrors?.length > 0) {
            //rimuovo la classe has-error
            for (let fieldWithError of fieldsWithErrors) {
                $(fieldWithError).removeClass('has-error');
            }
        }
        //controllo che non ci siano più errori, altrimenti aggiungo di nuovo has-error
        const dataKeys = Object.keys(data);
        let errorsCount = 0;
        for (let key of dataKeys) {
            //controllo che il formato dell'email sia giusto
            if (key === "Email" && !Pqp.validateEmail(data[key])) {
                errorsCount++;
                const errorElement = $(`.js-input-error-${key}`)[0];
                if (errorElement) {
                    const errorElementParent = errorElement.parentElement;
                    if (errorElementParent) {
                        errorElementParent.classList.add('has-error');
                        $("#user-email").closest(".single-input")
                            .find(".input-error")
                            .text("Formato dell'email sbagliato!");
                    }
                }
            }

            //Controllo formato profilo instagram
            if (key.toLowerCase().includes('instagram') && (!Pqp.isNullOrEmpty(data[key]) && !data[key].toLowerCase().includes('www.instagram.com/'))) {
                errorsCount++;
                const errorElement = $(`.js-input-error-${key}`)[0];
                if (errorElement) {
                    const errorElementParent = errorElement.parentElement;
                    if (errorElementParent) {
                        errorElementParent.classList.add('has-error');
                        $(`.js-input-error-${key}`)
                            .text("Il link al profilo deve contenere www.instagram.com/");
                    }
                }
            }

            //Controllo tutti i campi tranne UrlInstagramLocale e UidConcorso
            if ((key != 'UrlInstagramLocale' && key != "Email" && key != "UidConcorso" && !key.includes('instagram')) &&
                (data[key] == undefined || (typeof (data[key]) == 'string' && Pqp.isNullOrEmpty(data[key])))) {
                errorsCount++;
                //Se c'è un errore aggiungo la classe has-error
                const errorElement = $(`.js-input-error-${key}`)[0];
                if (errorElement) {
                    const errorElementParent = errorElement.parentElement;
                    if (errorElementParent) {
                        errorElementParent.classList.add('has-error');
                    }
                }
            }

            if (key.includes('FLAG') && key != 'FLAGPrivacyNewsletter' && data[key] == 0) {
                errorsCount++;
                //Se c'è un errore aggiungo la classe has-error
                const errorElement = $(`.js-input-error-${key}`)[0];
                if (errorElement) {
                    const errorElementParent = errorElement.parentElement;
                    if (errorElementParent) {
                        errorElementParent.classList.add('has-error');
                    }
                }
            }
        }

        return errorsCount == 0;
    }

    ManageFormDryCuracaoResponse(rs) {
        this.showPreloader(false);
        if (rs && rs.Success === true) {
            // show success...
            console.log("success!");
            let form = $(".js-form-ok", ".library").clone().appendTo(".land").show();
            // close form dialogs or reload the page
            $(".js-reload", form).on("click", (e) => { window.location.reload(true) });
            $(".js-dialog-close", form).on("click", (e) => { window.location.reload(true) });
        } else {

            if (rs && rs.StatusCode && rs.StatusCode === 409) {
                console.log("email già usata...");
                $("#user-email").closest(".single-input").addClass("has-error");
                $("#user-email").closest(".single-input")
                    .find(".input-error")
                    .text("L'email è già stata utilizzata!");

                $(".js-form-fields-error", ".library").clone().appendTo(".land").show();

                //Gestione modale in base agli errori
                $(".js-reload", ".land").on("click", (e) => { $(".form-dialog", ".land").remove() });
                $(".js-dialog-close", ".land").on("click", (e) => { $(".form-dialog", ".land").remove() });
            } else {
                if (rs.Message == 'Errore campi') {
                    let errors = rs.Exception.split(',');
                    for (let error of errors) {

                        let field = error.charAt(0).toUpperCase() + error.slice(1);
                        const errorElement = $(`.js-input-error-${field}`)[0];
                        if (errorElement) {
                            $(errorElement).text('Errore di validazione!');
                            const errorElementParent = errorElement.parentElement;
                            if (errorElementParent) {
                                errorElementParent.classList.add('has-error');
                            }
                        }
                    }
                    $(".js-form-fields-error", ".library").clone().appendTo(".land").show();
                    $(".js-reload", ".land").on("click", (e) => { $(".form-dialog", ".land").remove() });
                    $(".js-dialog-close", ".land").on("click", (e) => { $(".form-dialog", ".land").remove() });
                }
                else {
                    // show error generic... 
                    console.log("error generic");
                    $(".js-form-error", ".library").clone().appendTo(".land").show();
                    // close form dialogs or reload the page
                    $(".js-reload", ".land").on("click", (e) => { window.location.reload() });
                    $(".js-dialog-close", ".land").on("click", (e) => { $(".form-dialog", ".land").remove() });
                }
            }
        }
    }

    initUploadAll() {
        var id = "video-upload";
        var para = new TrixUloaderParams();
        para.UplElementTriggerId = id;
        para.UplMaxFileSize = "40"; // 40 MB
        para.UplMaxNumFile = 1; // <0 infinite
        para.UplElementDragId = id;
        para.UplDragEnabled = true;
        para.UplFilterTitle = "Video";
        para.UplFilterExtensions = "mpg,mpeg,avi,mp4,mov";
        para.UplFilterMimeTypes = "video/*";
        para.UplNaming = "ugc/Drycuracao2024/{GUID}.{NEXT}";
        // para.UplImageResample = "r=true,q=90,t=jpg,m=limit,s=1024x1024";
        para.UplRepositoryFolder = "/public/";
        //
        var uplObject = new TrixUloaderObject(para);
        uplObject.init(jQuery.proxy(this.uploadHandlerVideo, null, id));

        var id2 = "img-upload";
        var para2 = new TrixUloaderParams();
        para2.UplElementTriggerId = id2;
        para2.UplMaxFileSize = "6"; // 6 MB
        para2.UplMaxNumFile = 1; // <0 infinite
        para2.UplElementDragId = id2;
        para2.UplDragEnabled = true;
        para2.UplFilterTitle = "Foto";
        para2.UplFilterExtensions = "png,jpg,jpeg";
        para2.UplFilterMimeTypes = "image/*";
        para2.UplNaming = "ugc/Drycuracao2024/{GUID}.{NEXT}";
        // para2.UplImageResample = "r=true,q=90,t=jpg,m=limit,s=1024x1024";
        para2.UplRepositoryFolder = "/public/";
        //
        var uplObject2 = new TrixUloaderObject(para2);
        uplObject2.init(jQuery.proxy(this.uploadHandlerFoto, null, id2));
    }

    uploadHandlerFoto(id, ev) {
        if (ev.type == "start") {
            page.showPreloader(true);
            $(`#${id}`).closest(".single-input").removeClass("has-error");
            $(`#${id}`).closest(".single-input").removeClass("has-file-ok");

        } else if (ev.type == "progress") {

        } else if (ev.type == "error") {
            page.showPreloader(false);
            $("#" + id + "_content").text("Errore " + ev.data.Mex);
            $(`#${id}`).closest(".single-input").addClass("has-error");

        } else if (ev.type == "complete") {
            page.showPreloader(false);
            $(`#${id}`).closest(".single-input").addClass("has-file-ok");
            $("#" + id + "_content").text(ev.data.Files[0].OriFileName);
            $(".label-foto").css("opacity", 0);
            $(".js-img-upload").val(ev.data.Files[0].Url);
            console.log(ev.data.Files[0]);
        }
    }

    uploadHandlerVideo(id, ev) {
        if (ev.type == "start") {
            page.showPreloader(true);
            $(`#${id}`).closest(".single-input").removeClass("has-error");
            $(`#${id}`).closest(".single-input").removeClass("has-file-ok");

        } else if (ev.type == "progress") {

        } else if (ev.type == "error") {
            page.showPreloader(false);
            $("#" + id + "_content").text("Errore " + ev.data.Mex);
            $(`#${id}`).closest(".single-input").addClass("has-error");

        } else if (ev.type == "complete") {
            page.showPreloader(false);
            let video = document.createElement('video');
            let baseUrl = TheApp.Env.BaseUrlNls.slice(0, -1);
            video.src = baseUrl + ev.data.Files[0].Url;
            video.onloadedmetadata = () => {
                if (video.duration / 60 > 1) {
                    $(`#${id}`).closest(".single-input").removeClass("has-file-ok");
                    $("#" + id + "_content").text("Errore: il video deve durare massimo 1 minuto !");
                    $(`#${id}`).closest(".single-input").addClass("has-error");
                    return null; // Errore video
                }
            }
            $(`#${id}`).closest(".single-input").addClass("has-file-ok");
            $("#" + id + "_content").text(ev.data.Files[0].OriFileName);
            $(".label-foto").css("opacity", 0)
            $(".js-video-upload").val(ev.data.Files[0].Url);
            console.log(ev.data.Files[0]);
        }
    }

    checkForm(btnSubmit, form) {
        let nErrors = 0;
        jQuery(".has-error").removeClass("has-error");
        $(".form-dialog", ".land-subscribe").remove();

        let data = {
            Nome: $("#name"),
            Cognome: $("#surname"),
            Email: $("#email"),
            Telefono: $("#phone"),
            NomeLocale: $("#store-name"),
            RagioneSociale: $("#business-name"),
            Indirizzo: $("#store-address"),
            UrlInstagramBartender: $("#instagram-profile"),
            UrlInstagramLocale: $("#instagram-profile"),
            UrlFoto: $(".js-foto-file"),
            UrlVideo: $(".js-video-file"),
            NomeCocktail: $("#cocktail-name"),
            Ricetta: $("#recipe"),
            MetodoPreparazione: $('#preparation-method'),
            Guarnizione: $('#garnish'),
            Bicchiere: $("#glass"),
            FLAGprivacy: $("#privacy-policy"),
            FLAGpubblicazioneOnline: $("#pubblicazione-online"),
            FLAGprivacyNewsletter: $("#newsletter"),
        }

        this.initUploadAll();

        // actual check...
        const checkedData = this.checkFormData(data, nErrors);
        ({ data, nErrors } = checkedData);

        if (nErrors > 0) {
            $(".js-form-fields-error", ".library").clone().appendTo(".land-subscribe").show();
            // close form dialogs or reload the page
            $(".js-reload", ".land-subscribe").on("click", (e) => { window.location.reload() });
            $(".js-dialog-close", ".land-subscribe").on("click", (e) => { $(".form-dialog", ".land-subscribe").remove() });
            return;
        }

        data.FLAGprivacyNewsletter = $("#newsletter").is(":checked") ? 1 : 0;
        data.FLAGpubblicazioneOnline = $("#pubblicazione-online").is(":checked") ? 1 : 0;
        data.FLAGprivacy = $("#privacy-policy").is(":checked") ? 1 : 0;
        data.UidConcorso = this.UidConcorso;

        const rq = new Object({
            partecipante_drycuracao2024ToInsert: data
        });

        this.sendData(btnSubmit, rq);
    }

    sendData(btnSubmit, rq) {
        btnSubmit.style.pointerEvents = "none";
        $(".form-dialog", ".land-subscribe").remove();

        this.showPreloader(true);

        thatServiceManeger.standardCall("/api/drycuracao2024/doInsConcorso", rq, (rs) => {
            console.log(rs);
            btnSubmit.removeAttribute("style");
            this.showPreloader(false);

            if (rs && rs.Success === true) {
                // show success...
                console.log("success!");
                $(".js-form-ok", ".library").clone().appendTo(".land-subscribe").show();
                // close form dialogs or reload the page
                $(".js-reload", ".land-subscribe").on("click", (e) => { window.location.reload() });
                $(".js-dialog-close", ".land-subscribe").on("click", (e) => { window.location.reload() });

            } else {

                if (rs && rs.StatusCode && rs.StatusCode === 409) {
                    console.log("email già usata...");
                    $("#email").closest(".single-input-wrap").addClass("has-error");
                    $("#email").closest(".single-input-wrap")
                        .find(".input-error")
                        .text("L'email è già stata utilizzata!");

                    $(".js-form-fields-error", ".library").clone().appendTo(".land-subscribe").show();

                } else {
                    // show error generic... 
                    console.log("error generic");
                    $(".js-form-error", ".library").clone().appendTo(".land-subscribe").show();
                }

                // close form dialogs or reload the page
                $(".js-reload", ".land-subscribe").on("click", (e) => { window.location.reload() });
                $(".js-dialog-close", ".land-subscribe").on("click", (e) => { $(".form-dialog", ".land-subscribe").remove() });
            }
        });
    }

    checkFormData(data, nErrors) {
        for (const key in data) {
            /**
             * Custom fields check
             * */
            // check if email
            if (key === "email") {
                if (Pqp.isNullOrEmpty($.trim(data[key].val())) || !Pqp.validateEmail($.trim(data[key].val()))) {
                    data[key].closest(".single-input-wrap").addClass("has-error");
                    data[key].closest(".single-input-wrap")
                        .find(".input-error")
                        .text("Questo campo è obbligatorio!");
                    nErrors++;
                }

                data[key] = $.trim(data[key].val());

                // check if foto
            } else if (key === "UrlFoto") {
                if (Pqp.isNullOrEmpty($.trim(data[key].val()))) {
                    data[key].closest(".single-input-wrap").addClass("has-error");
                    nErrors++;
                }

                data[key] = $.trim(data[key].val());

                // check if video
            } else if (key === "UrlVideo") {
                if (Pqp.isNullOrEmpty($.trim(data[key].val()))) {
                    data[key].closest(".single-input-wrap").addClass("has-error");
                    nErrors++;
                }

                data[key] = $.trim(data[key].val());

                // check if is acceptance privacy
            } else if (key === "FLAGprivacy") {
                if (!data[key].is(":checked")) {
                    data[key].closest(".single-input-wrap").addClass("has-error");
                    data[key] = 0;
                    nErrors++;

                } else {
                    data[key] = 1;
                }

                // check if is acceptance newsletter
            } else if (key === "FLAGprivacyNewsletter") {
                if (!data[key].is(":checked")) {
                    data[key] = 0;

                } else {
                    data[key] = 1;
                }

            } else if (key === "FLAGpubblicazioneOnline") {
                if (!data[key].is(":checked")) {
                    data[key] = 0;

                } else {
                    data[key] = 1;
                }

            } else {
                /**
                 * Mandatory normal fields
                 * */
                if (data[key].attr("data-mandatory") === "true") {
                    if (Pqp.isNullOrEmpty($.trim(data[key].val()))) {
                        data[key].closest(".single-input-wrap").addClass("has-error");
                        nErrors++;
                    }
                }

                data[key] = $.trim(data[key].val());
            }
        }

        return { data, nErrors }
    }

    initForm() {
        const form = document.querySelector("#form-candidatura");

        if (form) {
            const btnSubmit = form.querySelector(".js-check-form");
            btnSubmit?.addEventListener("click", this.checkForm.bind(this, btnSubmit, form));

        } else {
            return;
        }
    }

    initNav() {
        const siteNav = document.querySelector(".js-site-nav");
        if (siteNav) {
            const navVoices = siteNav.querySelectorAll(".js-nav-voice");
            let flagOpen = false;
            let voiceListWidth;

            if (window.innerWidth > 767) {
                voiceListWidth = jQuery(".js-nav-voicelist", siteNav).width();

            } else {
                voiceListWidth = window.innerWidth;
            }

            jQuery(".js-nav-voicelist", siteNav)?.css({ "width": 0 });

            siteNav.querySelector(".js-open-nav")?.addEventListener("click", (e) => {
                if (flagOpen) {
                    flagOpen = false;
                    jQuery(".js-nav-voicelist", siteNav)?.css({ "width": 0 });

                } else {
                    flagOpen = true;
                    jQuery(".js-nav-voicelist", siteNav)?.css({ "width": `${voiceListWidth}px` });
                }

                siteNav.querySelector(".js-open-nav").classList.toggle("is-clicked");
            });

            if (navVoices.length > 0) {
                navVoices.forEach((voice) => {
                    voice.addEventListener("click", (e) => {
                        siteNav.querySelector(".js-open-nav")?.click();
                    });
                })
            }

        } else {
            return;
        }
    }

    ageCheck() {
        const dialog = document.querySelector(".js-age-check");

        if (Pqp.isNullOrEmpty(jQuery.cookie("wlfFlagCookie_CURACAO_AGE"))) {
            dialog?.classList.remove("is-hidden");
            document.querySelector("body").style.cssText = `
        height: 100vh;
        overflow: hidden;
      `;

        } else {
            this.hideAgeCheckDialog(dialog);
        }

        $(".js-yes").on("click", () => { this.confirmAge(dialog) });
    }

    hideAgeCheckDialog(dialog) {
        dialog?.classList.add("is-hidden");
        document.querySelector("body").removeAttribute("style");
    }

    confirmAge(dialog) {
        jQuery.cookie("wlfFlagCookie_CURACAO_AGE", "TRUE", {
            expires: 180,
            path: "/"
        });

        this.hideAgeCheckDialog(dialog);
    }
}